import { css } from "@/domains/emotion";
import { FC, memo } from "react";

interface MdsSpacerProps {
  flexGrow?: number;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsSpacer: FC<MdsSpacerProps> = memo(({ flexGrow = 1 }) => {
  const className = css({
    flex: "1",
    flexGrow,
  });

  return <div className={className} />;
});
